import React from 'react';
import I18n from '@/modules/i18n';
import { useModalManager } from '@/components/common/Modal';
import EditContactAdminModal from '@/components/admin/subscribers/EditContactAdmin/EditContactAdminModal';
import Text from '@/components/ui/Text';
import SettingsToggle from './SettingsToggle';

interface CommunicationSettingsProps {
  contactAdminsPath: string;
  disabled: boolean;
  onToggle: (checked: boolean) => void;
  receiveWeeklyEmails: boolean;
  subscriberApiPath: string;
}

const CommunicationSettings = ({
  contactAdminsPath,
  disabled,
  onToggle,
  receiveWeeklyEmails,
  subscriberApiPath,
}: CommunicationSettingsProps) => {
  const modalManager = useModalManager();

  return (
    <div>
      <Text className="tw-mb-2" size="xl" tag="h2" variant="label">
        {I18n.t('communication')}
      </Text>
      <div className="tw-space-y-2">
        <div>
          <Text size="sm" tag="span" weight="bold">
            {I18n.t('contact_admin_popup')}
          </Text>
          <Text className="tw-text-very-dark-grey" size="sm">
            {I18n.t('contact_admin_popup_description')}
          </Text>
          <div className="tw-pt-2">
            <button
              className="btn btn--outline-purple"
              type="button"
              onClick={modalManager.open}
            >
              {I18n.t('edit_contact_admin_popup')}
            </button>
          </div>
          {modalManager.isOpen && (
            <EditContactAdminModal
              getContactAdminsPath={contactAdminsPath}
              modalManager={modalManager}
              subscriberPath={subscriberApiPath}
            />
          )}
        </div>

        <SettingsToggle
          checked={receiveWeeklyEmails}
          description={I18n.t('receive_tci_digest_emails_description')}
          disabled={disabled}
          id="admin-setting-receive-weekly-emails"
          label={I18n.t('receive_tci_digest_emails')}
          onChange={onToggle}
        />
      </div>
    </div>
  );
};

export default CommunicationSettings;
